import { Box, Typography } from "@mui/material";
import { formatMXN, formatShort, getSegmentColor } from "./factoraje.helpers";

export interface SegmentoReparto {
  id: string;
  nombre: string;
  monto: number;
}

interface Props {
  segmentos: SegmentoReparto[];
  /** Total de la línea: el 100% de la barra. */
  linea: number;
}

/**
 * Replica `.fxu-bar` + `.fxu-scale` del diseño de Flux: un segmento por empresa, proporcional a su
 * monto sobre la línea, y la escala `$0 · mitad · total` debajo.
 */
export const BarRepartoLinea = ({ segmentos, linea }: Props) => (
  <>
    <Box
      sx={{
        display: "flex",
        gap: "2px",
        height: 12,
        borderRadius: "6px",
        overflow: "hidden",
        bgcolor: "#F2F5F9",
        mt: 2,
      }}
    >
      {segmentos.map((segmento, i) =>
        segmento.monto > 0 ? (
          <Box
            key={segmento.id}
            title={`${segmento.nombre || "Cliente"} · ${formatMXN(segmento.monto)}`}
            sx={{
              height: "100%",
              width: `${(segmento.monto / Math.max(linea, 1)) * 100}%`,
              bgcolor: (theme) => getSegmentColor(theme, i),
              borderRadius: "3px",
              transition: "width .2s cubic-bezier(.4,0,.2,1)",
            }}
          />
        ) : null,
      )}
    </Box>
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: "6px" }}>
      {[0, linea / 2, linea].map((mark, i) => (
        <Typography key={i} sx={{ fontSize: 10.5, color: "text.secondary", fontVariantNumeric: "tabular-nums" }}>
          {formatShort(mark)}
        </Typography>
      ))}
    </Box>
  </>
);
